import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { trackComparisonEmptyButtonClick, trackComparisonLandingClick } from './tracking';
import { ComparisonEmpty } from '../../components/ComparisonEmpty';
import { ComparisonLanding, ComparisonLandingSkeleton } from '../../components/ComparisonLanding';
import { NEWBUILDING_COMPARISON_URL } from '../../constants/newbuildingCompare';
import {
  EPropertyType,
  type IComparisonAlbum,
} from '../../repositories/property-comparison/entities/v1_get_comparison_albums/ComparisonAlbum';
import { selectComparisonAlbums, selectNewbuildingComparisonAlbum } from '../../selectors/comparisonAlbums';
import { selectUser } from '../../selectors/user';
import { EComparisonAlbumsStatus } from '../../types/comparisonAlbums';
import { EEntityType } from '../../types/filters';
import { type TThunkDispatch } from '../../types/redux';
import { getSearchUrl } from '../../utils/filters';
import { getComparisonAlbums } from '../../thunk/comparisonAlbums/getComparisonAlbums';

const EMPTY_NEWBUILDING_ALBUM: IComparisonAlbum = {
  title: 'ЖК',
  subtitle: 'Нет объектов',
  propertyType: EPropertyType.Newbuilding,
  images: [],
};

export const ComparisonLandingContainer: React.FC = () => {
  const dispatch = useDispatch<TThunkDispatch>();
  const user = useSelector(selectUser);
  const { status } = useSelector(selectComparisonAlbums);
  const album = useSelector(selectNewbuildingComparisonAlbum);

  React.useEffect(() => {
    if (status === EComparisonAlbumsStatus.Initial) {
      dispatch(getComparisonAlbums());
    }
  }, [dispatch, status]);

  const handleSearchClick = React.useCallback(() => {
    trackComparisonEmptyButtonClick();
    window.location.assign(getSearchUrl({ dealType: null, favoriteEntityType: EEntityType.Newbuilding }));
  }, []);

  if (!user.isAuthenticated) {
    return <ComparisonEmpty variant="unauthorized" onButtonClick={handleSearchClick} />;
  }

  if (status === EComparisonAlbumsStatus.Initial || status === EComparisonAlbumsStatus.Loading) {
    return <ComparisonLandingSkeleton />;
  }

  return (
    <ComparisonLanding
      album={album || EMPTY_NEWBUILDING_ALBUM}
      url={NEWBUILDING_COMPARISON_URL}
      onClick={trackComparisonLandingClick}
    />
  );
};
